// extracted by mini-css-extract-plugin
export default {"emptyPlaceholderChartsContainer":"styles_emptyPlaceholderChartsContainer__8h6pV"};